<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_github", "footer", "github")' href="https://github.com/azizlass12" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a (click)='analyticsService.sendAnalyticEvent("click_linkedin", "footer", "github")' href="https://www.linkedin.com/in/lassoued-aziz-353839227" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
        </ul>
        <!-- <div class="footer-right-bar d-none d-md-block">
            <a (click)='analyticsService.sendAnalyticEvent("click_send_mail", "footer", "email")'  target='_blank'>andresjosehr&#64;gmail.com </a>
        </div> -->
    </div>

    <div class="footer-credits text-center" >
        <a  target="_blank" rel="nofollow noopener noreferrer">
            <div>Built with Angular by Aziz lassoued</div>
        </a>
       
    </div>

</footer>